<template>
  <div>
    <b-row>
      <b-col>
        <b-table
          :busy="loading"
          :fields="tableDataFields"
          :items="tableData"
          responsive
          head-variant="light"
          class="bg-white"
          show-empty
        >
          <template v-slot:cell(col1)="data">
            <div>
              <span class="table-text">{{ data.item.contactName }}</span>
            </div>
            <div>
              <span class="table-text">{{ data.item.contactJob }}</span>
            </div>
          </template>
          <template v-slot:cell(col2)="data">
            <div>
              <i class="el-icon-mobile-phone table-text"></i>
              <span class="table-text ml-2">{{ data.item.contactMobile }}</span>
            </div>
            <div>
              <i class="el-icon-phone-outline table-text"></i>
              <span class="table-text ml-2">{{ data.item.contactPhone }}</span>
            </div>
            <div>
              <i class="el-icon-message table-text" />
              <span class="table-text ml-2">{{ data.item.contactEmail }}</span>
            </div>
          </template>
          <template v-slot:cell(col3)="data">
            <div>
              <div>
                <i class="el-icon-office-building table-text"></i>
                <a class="table-text ml-2" role="button" @click="viewScmDetail(data.item.scmCode)">
                  <b>{{ data.item.companyName }}</b>
                </a>
              </div>
              <div>
                <i class="el-icon-map-location table-text"></i>
                <span class="table-text ml-2">
                  {{
                  data.item.companyAddress
                  }}
                </span>
              </div>
              <div>
                <i class="el-icon-time table-text"></i>
                <span class="table-text ml-2">{{ data.item.modifyDate }}</span>
                <span style="font-size: 15px" class="ml-2">
                  <b-badge
                    :variant="data.item.contactStatus === 'Y' ? 'success' : ''"
                  >{{ data.item.contactStatusName }}</b-badge>
                </span>
              </div>
              <!-- <span style="font-size: 15px" class="ml-2">
                <b-badge
                  :variant="data.item.lingkScmName === '--' ? '' : 'success'"
                  >{{ data.item.lingkScmName }}
                </b-badge>
              </span>-->
            </div>
          </template>
          <template v-slot:cell(col4)="data">
            <div>
              <div class="d-flex justify-content-start">
                <span style="font-size: 15px">
                  <b-badge
                    :variant="data.item.contactStatus === 'Y' ? 'success' : ''"
                  >{{ data.item.contactStatusName }}</b-badge>
                </span>
                <span style="font-size: 15px" class="ml-2">
                  <b-badge
                    :variant="data.item.lingkScmName === '--' ? '' : 'success'"
                  >{{ data.item.lingkScmName }}</b-badge>
                </span>
              </div>
              <span class="table-text">{{ data.item.modifyDate }}</span>
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center">
              <el-dropdown trigger="click" @command="handleCommand">
                <b-button variant="light">
                  <i class="el-icon-more"></i>
                </b-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    icon="el-icon-view"
                    :command="'view:' + data.item.scmInfoUserContactsCode"
                  >
                    {{
                    $l("table_contact_btn_view") || "查看名片"
                    }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    icon="el-icon-delete"
                    divided
                    :command="'del:' + data.item.scmInfoUserContactsCode"
                  >
                    {{
                    $l("table_contact_btn_del") || "删除名片"
                    }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center" class="mt-5">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">{{ $l("INDEX.tips_no_data") || "暂无数据！" }}</p>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data() {
    return {
      tableDataFields: [
        {
          key: "col1",
          label: this.$l("table_contact_label_name") || "联系人",
          tdClass: "align-middle ",
          thStyle:
            "color:#6c757d; border: 0!important; background-color: #f1f3fa; font-size:14.4px;"
        },
        {
          key: "col2",
          label: this.$l("table_contact_label_phone") || "电话/邮箱",
          tdClass: "align-middle",
          thStyle:
            "color:#6c757d; border: 0!important; background-color: #f1f3fa; font-size:14.4px;"
        },
        {
          key: "col3",
          label: this.$l("table_contact_label_company") || "公司",
          tdClass: "align-middle",
          thStyle:
            "color:#6c757d; border: 0!important; background-color: #f1f3fa; font-size:14.4px;"
        },
        // {
        //   key: "col4",
        //   label: this.$l("table_scm_label_modifyInfo") || "最新更新",
        //   tdClass: "align-middle",
        //   thStyle:
        //     "color:#6c757d; border: 0!important; background-color: #f1f3fa; font-size:14.4px;",
        // },
        {
          key: "operation",
          label: this.$l("table_scm_label_operation") || "操作",
          tdClass: "align-middle",
          thStyle:
            "color:#6c757d; border: 0!important; background-color: #f1f3fa; font-size:14.4px;text-align: center;"
        }
      ]
    };
  },
  methods: {
    viewScmDetail(val) {
      this.$emit("viewScmDetail", val);
    },
    handleCommand(command) {
      this.$emit("handleCommand", command);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-text {
  color: #6c757d;
  font-size: 14.4px;
}

// font-size: 14px; color: #606266
</style>
